import { SupabaseClient } from "@supabase/supabase-js";

/**
 * Checks if the user is a Northstar admin.
 * Grants access to:
 * 1. Users with @ntmllc.com email addresses
 * 2. Users explicitly listed in the northstar_admins table
 *
 * @param supabase - The Supabase client
 * @param email - The email of the user
 * @returns True if the user is a Northstar admin, false otherwise
 * @throws An error if there is an issue fetching the northstar admin
 */
export async function isUserEmailNorthstarAdmin(supabase: SupabaseClient, email: string): Promise<boolean> {
  // Check if user has @ntmllc.com email
  if (email.endsWith("@ntmllc.com")) {
    return true;
  }

  // Check if user is in northstar_admins table
  const { data, error } = await supabase
    .schema("nowadays")
    .from("northstar_admins")
    .select("*")
    .eq("email", email)
    .maybeSingle();

  if (error) {
    throw new Error(`Error fetching northstar admin: ${error.message}`);
  }

  return !!data;
}
